import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { jackpotHistoryDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { DATE_FORMAT } from "helpers/common";
import { FadeLoader } from "react-spinners";

export default function BalanceTransactionModal({
  show,
  handleClose,
  title,
  id,
  data,
}) {
  const { loading } = useSelector(({ Jackpot }) => Jackpot);
  // const [data, setData] = useState(null);

  const dispatch = useDispatch();


  const status = {
    active: "Active",
    completed: "Completed",
    ended: "Ended",
  };

  return loading ? (
    <div className="main-loader">
      <FadeLoader size={1000} />
    </div>
  ) : (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        {/* <Modal.Title className="fw-bold text-dark">{title}</Modal.Title> */}
      </Modal.Header>

      <Modal.Body>
        <>
          <section className="section">
            <div className="section-header">
              <h1>{title}</h1>
            </div>
            {/* {data?.userDetails?.adminNote ?
              <p>
                <b>
                  Note: </b> <span>{data?.userDetails?.adminNote}</span>
              </p>
              : ""} */}
            <div className="section-body">
              <div className="card">
                <Row>
                  <Col lg="12" className="my-2 px-4">
                    {/* <h4 className="text-primary">Match Details</h4> */}
                    <ul className="list-unstyled ps-0 mb-0 mt-3 row">
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className=" ">
                          Admin Name :{" "}
                          <span className="font-weight-bold">
                            {data?.adminDetails?.name || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className=" ">
                          Admin Email :{" "}
                          <span className="font-weight-bold">
                            {data?.adminDetails?.email || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Type:{" "}
                          <span className="font-weight-bold">
                            {data?.type || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Amount:{" "}
                          <span className="font-weight-bold">
                            {data?.amount || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Coin Name :{" "}
                          <span className="font-weight-bold">
                            {data?.coinName || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Coin Icon :{" "}
                          <img
                            src={data?.coinIcon}
                            className="img-fluid object-fit-contain"
                            style={{ height: 50, width: 50 }}
                          />
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Coin Symbol :{" "}
                          <span className="font-weight-bold">
                            {data?.coinSymbol || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          New Coin Balance :{" "}
                          <span className="font-weight-bold">
                            {data?.newCoinBalance || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Prev Coin Balance :{" "}
                          <span className="font-weight-bold">
                            {data?.prevCoinBalance || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Transaction Type :{" "}
                          <span className="font-weight-bold">
                            {data?.transactionType || "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Created At :{" "}
                          <span className="font-weight-bold">
                            {data?.date_created_utc
                              ? DATE_FORMAT(data?.date_created_utc)
                              : "--"}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-12 my-2">
                        <p className="">
                          Comment :{" "}
                          <span className="font-weight-bold">
                            {data?.comment || "--"}
                          </span>
                        </p>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </div>
          </section>
        </>
      </Modal.Body>
    </Modal>
  );
}
